// Which tally does a facet render — the one for THIS search, or the corpus snapshot?
//
// B914 follow-up, owner-reported: *"when I filter it shows correct less count but when filter
// removed it dont go back to show full numbers"*.
//
// The trap is that clearing a filter does NOT re-answer the facet. Two mechanisms conspire:
//   * the unfiltered browse takes the cheap recent-feed read, which carries no `search_meta`
//     at all — so nothing arrives to overwrite the scoped numbers; and
//   * the counts prewarm, which IS what produces corpus-wide numbers, is ref-deduped per
//     `dcKey`, so it fires once and not again when the filter comes off.
// Holding ONE state for both answers therefore leaves the filtered numbers on screen with no
// filter to explain them — or, if the absent meta is written through as null, blanks them.
//
// So the two answers are kept apart and chosen between. The rule is small enough to look
// obvious and was wrong in production twice, which is why it lives here with tests instead of
// as a ternary in a 12,000-line component.
//
// ⚠️ `filtered` MUST be the same predicate the prewarm guards on (`serverAdvFilters ||
// committedQ`). The prewarm is the only thing that fills `corpus`; if this function's idea of
// "unfiltered" is wider than the prewarm's, it will read a snapshot that was never taken.
//
// ⚠️ null is not 0. An unarrived tally renders NO number — the same rule the street facet and
// the corpus total follow. Returning 0 would assert "nothing matches", which is a different
// statement and the one this whole row exists to stop making.
export function pickFacetCounts({ isLeads = false, leads = null, scoped = null, corpus = null, filtered = false } = {}) {
    // The leads pool answers from its own feed's meta and has no separate corpus snapshot:
    // its prewarm equivalent is the feed itself, so there is only one answer to give.
    if (isLeads) return leads || null
    return (filtered ? scoped : corpus) || null
}
